"use client";

import React from "react";
import WithDrawerOpen from "@/shared/ui/gestures/WithDrawerOpen";
import { MeiliOrigin, MeiliOriginProcessedStatus } from "@/generated/fastapi";
import { useBacklogOriginDrawers } from "../contexts/BacklogOriginDrawersProvider";
import SourceExtractionWorkflow from "../workflows/source-extraction/SourceExtractionWorkflow";
import IdentifyTopicsWorkflow from "../workflows/topic-review/IdentifyTopicsWorkflow";
import { PROFILE_SHAPING_LABELS } from "@/features/profile-shaping";

/**
 * Centralized drawer management for Backlog
 */
export default function BacklogDrawers() {
  const {
    extractThoughtsDrawer,
    identifyTopicsDrawer,
    closeExtractThoughtsDrawer,
    closeIdentifyTopicsDrawer,
  } = useBacklogOriginDrawers();

  return (
    <>
      {extractThoughtsDrawer && (
        <WithDrawerOpen
          title={PROFILE_SHAPING_LABELS.flow}
          isOpen={true}
          onOpenChangeAction={(isOpen: boolean) => {
            if (!isOpen) {
              closeExtractThoughtsDrawer();
            }
          }}
          onCloseAction={closeExtractThoughtsDrawer}
        >
          <SourceExtractionWorkflow
            meiliOrigin={
              {
                objectID: extractThoughtsDrawer.originId,
                raw_text_input: extractThoughtsDrawer.originContent,
                processed_status: "UNPROCESSED" as MeiliOriginProcessedStatus,
                language: extractThoughtsDrawer.language,
              } as MeiliOrigin
            }
            onUpdateSearchResultAction={() => {
              extractThoughtsDrawer.onExtractionSuccess?.();
            }}
          />
        </WithDrawerOpen>
      )}

      {identifyTopicsDrawer && (
        <WithDrawerOpen
          title={PROFILE_SHAPING_LABELS.findTopics}
          isOpen={true}
          onOpenChangeAction={(isOpen: boolean) => {
            if (!isOpen) {
              closeIdentifyTopicsDrawer();
            }
          }}
          onCloseAction={closeIdentifyTopicsDrawer}
        >
          <IdentifyTopicsWorkflow
            originId={identifyTopicsDrawer.originId}
            onCancel={closeIdentifyTopicsDrawer}
          />
        </WithDrawerOpen>
      )}
    </>
  );
}
